import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import React from 'react';
import { Box } from '../../../CommonComponents/OPL/Box/Box';
import { CheckoutForm } from './components/CheckoutForm/CheckoutForm';
import { Description } from './components/Description';

const stripePromise = loadStripe(ADV.settings.tokens.stripePubKey);

export const Payment: React.FC = () => (
  <Box display="flex" justifyContent="center">
    <Description />
    <Elements stripe={stripePromise}>
      <CheckoutForm />
    </Elements>
  </Box>
);
